// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import type {
  CafCommitInput,
  CafCommitResponse,
  CafPreviewResponse,
} from "../models/cafImport";

export default function useCafStatementImport() {
  const axios = useAuthenticatedAxios();

  async function preview(file: File): Promise<CafPreviewResponse> {
    const formData = new FormData();
    formData.append("file", file);
    const res = await axios.post("/caf-imports/preview", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }

  async function commit(
    file: File,
    payload: CafCommitInput,
  ): Promise<CafCommitResponse> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("payload", JSON.stringify(payload));
    const res = await axios.post("/caf-imports/commit", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  }

  return { preview, commit };
}
